<div class="d-flex justify-content-center">
  <div class="col-12 col-md-8">
    <form name="editForm" novalidate (ngSubmit)="save()" [formGroup]="editForm">
      <h4
        id="jhi-job-apply-heading"
        data-cy="JobApplyCreateUpdateHeading"
        jhiTranslate="recruitmentApp.jobApply.create.title"
        [translateValues]="{ jobTitle: job?.title }"
      >
        Apply job: {{ job?.title }}
      </h4>

      <div>
        <jhi-alert-error></jhi-alert-error>

        <!-- Name -->
        <div class="mb-3">
          <label class="form-label required mb-0" for="field_name" jhiTranslate="recruitmentApp.jobApply.create.name">Name</label>
          <div id="nameHelpBlock" class="form-text" style="margin-top: 0; margin-bottom: 0.5rem">
            Please enter your full name as it appears on official documents.
          </div>
          <input type="text" class="form-control" name="name" id="field_name" data-cy="name" formControlName="name" />
          @if (editForm.get('name')!.invalid && (editForm.get('name')!.dirty || editForm.get('name')!.touched)) {
            <div>
              @if (editForm.get('name')?.errors?.required) {
                <small class="form-text text-danger" jhiTranslate="entity.validation.required">This field is required.</small>
              }
              @if (editForm.get('name')?.errors?.maxlength) {
                <small class="form-text text-danger" jhiTranslate="entity.validation.maxlength" [translateValues]="{ max: '100' }"
                  >This field cannot be longer than 100 characters.</small
                >
              }
            </div>
          }
        </div>

        <div class="mb-3">
          <label class="form-label required mb-0" for="field_phone" jhiTranslate="recruitmentApp.jobApply.create.phone">Phone</label>
          <div class="form-text" style="margin-top: 0; margin-bottom: 0.5rem">
            Provide a contact number where you can be reached easily.
          </div>
          <input type="text" class="form-control" name="phone" id="field_phone" data-cy="phone" formControlName="phone" />
          @if (editForm.get('phone')!.invalid && (editForm.get('phone')!.dirty || editForm.get('phone')!.touched)) {
            <div>
              @if (editForm.get('phone')?.errors?.maxlength) {
                <small class="form-text text-danger" jhiTranslate="entity.validation.maxlength" [translateValues]="{ max: '10' }"
                  >This field cannot be longer than 10 characters.</small
                >
              }
            </div>
          }
        </div>

        <div class="mb-3">
          <label class="form-label required mb-0" for="field_email" jhiTranslate="recruitmentApp.jobApply.create.email">Email</label>
          <div class="form-text" style="margin-top: 0; margin-bottom: 0.5rem">
            Enter a valid email address for communication and updates.
          </div>
          <input
            type="email"
            class="form-control"
            name="email"
            id="field_email"
            data-cy="email"
            formControlName="email"
            placeholder="name@example.com"
          />
          @if (editForm.get('email')!.invalid && (editForm.get('email')!.dirty || editForm.get('email')!.touched)) {
            <div>
              @if (editForm.get('email')?.errors?.required) {
                <small class="form-text text-danger" jhiTranslate="entity.validation.required">This field is required.</small>
              }
            </div>
          }
        </div>

        <div class="mb-3">
          <label class="form-label required mb-0" for="field_eduQualify" jhiTranslate="recruitmentApp.jobApply.create.eduQualify"
            >Edu Qualify</label
          >
          <div class="form-text" style="margin-top: 0; margin-bottom: 0.5rem">Indicate your highest degree or relevant certifications.</div>
          <select class="form-select" name="eduQualify" formControlName="eduQualify" id="field_eduQualify" data-cy="eduQualify">
            <option [ngValue]="null">{{ 'recruitmentApp.education.null' | translate }}</option>
            @for (education of educationValues; track $index) {
              <option [value]="education">{{ 'recruitmentApp.education.' + education | translate }}</option>
            }
          </select>
          @if (editForm.get('eduQualify')!.invalid && (editForm.get('eduQualify')!.dirty || editForm.get('eduQualify')!.touched)) {
            <div>
              @if (editForm.get('eduQualify')?.errors?.required) {
                <small class="form-text text-danger" jhiTranslate="entity.validation.required">This field is required.</small>
              }
            </div>
          }
        </div>

        <div class="mb-3">
          <label class="form-label required mb-0" for="field_experienceYear" jhiTranslate="recruitmentApp.jobApply.create.experienceYear"
            >Experience Year</label
          >
          <div class="form-text" style="margin-top: 0; margin-bottom: 0.5rem">
            Indicate the total years of experience in your field or related roles.
          </div>
          <select
            class="form-select"
            aria-label="Default select example"
            name="experienceYear"
            id="field_experienceYear"
            data-cy="experienceYear"
            formControlName="experienceYear"
          >
            <option [ngValue]="null">--Select--</option>
            <option value="0">0 years</option>
            <option value="1">1 years</option>
            <option value="2">2 years</option>
            <option value="3">3 years</option>
            <option value="4">4 years</option>
            <option value="5">5 years</option>
            <option value="6">6 years</option>
            <option value="7">7 years</option>
            <option value="8">8 years</option>
            <option value="9">9 years</option>
            <option value="10">10 years</option>
            <option value="11">11 years</option>
            <option value="12">12 years</option>
            <option value="13">13 years</option>
            <option value="14">14 years</option>
            <option value="15">15 years</option>
            <option value="16">16 years</option>
            <option value="17">17 years</option>
            <option value="18">18 years</option>
            <option value="19">19 years</option>
            <option value="20">20 years</option>
            <option value="21">21 years</option>
            <option value="22">22 years</option>
            <option value="23">23 years</option>
            <option value="24">24 years</option>
            <option value="25">25 years</option>
            <option value="26">26 years</option>
            <option value="27">27 years</option>
            <option value="28">28 years</option>
            <option value="29">29 years</option>
            <option value="30">30 years</option>
          </select>
          @if (
            editForm.get('experienceYear')!.invalid && (editForm.get('experienceYear')!.dirty || editForm.get('experienceYear')!.touched)
          ) {
            <div>
              @if (editForm.get('experienceYear')?.errors?.required) {
                <small class="form-text text-danger" jhiTranslate="entity.validation.required">This field is required.</small>
              }
              @if (editForm.get('experienceYear')?.errors?.min) {
                <small class="form-text text-danger" jhiTranslate="entity.validation.min" [translateValues]="{ min: '0' }"
                  >This field should be at least 0.</small
                >
              }
              @if (editForm.get('experienceYear')?.errors?.max) {
                <small class="form-text text-danger" jhiTranslate="entity.validation.max" [translateValues]="{ max: '50' }"
                  >This field cannot be more than 50.</small
                >
              }
              <small
                class="form-text text-danger"
                [hidden]="!editForm.get('experienceYear')?.errors?.number"
                jhiTranslate="entity.validation.number"
                >This field should be a number.</small
              >
            </div>
          }
        </div>

        <div class="mb-3">
          <label
            class="form-label required mb-0"
            for="field_expecSalary"
            style="margin-bottom: 0"
            jhiTranslate="recruitmentApp.jobApply.create.expecSalary"
            >Expec Salary</label
          >
          <div id="expecSalaryHelpBlock" class="form-text" style="margin-top: 0; margin-bottom: 0.5rem">
            Specify your desired salary based on your qualifications and market standards. Input your expected salary in USD. For example:
            500
          </div>
          <input
            type="number"
            class="form-control"
            name="expecSalary"
            id="field_expecSalary"
            data-cy="expecSalary"
            formControlName="expecSalary"
            aria-describedby="expecSalaryHelpBlock"
          />
          @if (editForm.get('expecSalary')!.invalid && (editForm.get('expecSalary')!.dirty || editForm.get('expecSalary')!.touched)) {
            <div>
              @if (editForm.get('expecSalary')?.errors?.required) {
                <small class="form-text text-danger" jhiTranslate="entity.validation.required">This field is required.</small>
              }
              <small
                class="form-text text-danger"
                [hidden]="!editForm.get('expecSalary')?.errors?.number"
                jhiTranslate="entity.validation.number"
                >This field should be a number.</small
              >
            </div>
          }
        </div>

        <div class="mb-3">
          <label class="form-label required mb-0" for="field_industry" jhiTranslate="recruitmentApp.jobApply.create.industry"
            >Industry</label
          >
          <div class="form-text" style="margin-top: 0; margin-bottom: 0.5rem">
            Select the industry that best matches your education/professional background.
          </div>
          <select
            class="form-select"
            id="field_industry"
            data-cy="industry"
            name="industry"
            formControlName="industry"
            [compareWith]="compareIndustry"
          >
            <option [ngValue]="null">--Select--</option>
            @for (industryOption of industriesSharedCollection; track $index) {
              <option [ngValue]="industryOption">{{ industryOption.name }}</option>
            }
          </select>
          @if (editForm.get('industry')!.invalid && (editForm.get('industry')!.dirty || editForm.get('industry')!.touched)) {
            <div>
              @if (editForm.get('industry')?.errors?.required) {
                <small class="form-text text-danger" jhiTranslate="entity.validation.required">This field is required.</small>
              }
            </div>
          }
        </div>

        <div class="mb-3">
          <label class="form-label required mb-0" for="field_citizenship" jhiTranslate="recruitmentApp.jobApply.create.citizenship"
            >Citizenship</label
          >
          <div class="form-text" style="margin-top: 0; margin-bottom: 0.5rem">
            Indicate your citizenship status for employment eligibility.
          </div>
          <select class="form-select" name="citizenship" formControlName="citizenship" id="field_citizenship" data-cy="citizenship">
            <option [ngValue]="null">{{ 'recruitmentApp.citizenship.null' | translate }}</option>
            @for (citizenship of citizenshipValues; track $index) {
              <option [value]="citizenship">{{ 'recruitmentApp.citizenship.' + citizenship | translate }}</option>
            }
          </select>
          @if (editForm.get('citizenship')!.invalid && (editForm.get('citizenship')!.dirty || editForm.get('citizenship')!.touched)) {
            <div>
              @if (editForm.get('citizenship')?.errors?.required) {
                <small class="form-text text-danger" jhiTranslate="entity.validation.required">This field is required.</small>
              }
            </div>
          }
        </div>

        <div class="mb-3">
          <label class="form-label required mb-0" for="field_selfDescription" jhiTranslate="recruitmentApp.jobApply.create.selfDescription"
            >Self Description</label
          >
          <div class="form-text" style="margin-top: 0; margin-bottom: 0.5rem">
            Briefly describe yourself that showcase your skills, qualifications, professional experience and fit for the role. Minimum 500
            words.
          </div>
          <textarea
            rows="15"
            class="form-control"
            name="selfDescription"
            id="field_selfDescription"
            data-cy="selfDescription"
            formControlName="selfDescription"
            (keydown)="wordCounter()"
            #text
            oncopy="return false;"
            onpaste="return false;"
          ></textarea>
          <div class="form-text">
            Words: <span id="wordCount">{{ words }}</span>
          </div>
          @if (
            editForm.get('selfDescription')!.invalid && (editForm.get('selfDescription')!.dirty || editForm.get('selfDescription')!.touched)
          ) {
            <div>
              @if (editForm.get('selfDescription')?.errors?.required) {
                <small class="form-text text-danger" jhiTranslate="entity.validation.required">This field is required.</small>
              }
              @if (editForm.get('selfDescription')?.errors?.minWords) {
                <small class="form-text text-danger"> This field is required to be at least 500 words.</small>
              }
              @if (editForm.get('selfDescription')?.errors?.maxlength) {
                <small class="form-text text-danger" jhiTranslate="entity.validation.maxlength" [translateValues]="{ max: '10000' }"
                  >This field cannot be longer than 10000 characters.</small
                >
              }
            </div>
          }
        </div>

        <div class="mb-3">
          <label class="form-label required mb-0" for="field_cv" jhiTranslate="recruitmentApp.jobApply.create.cv">CV</label>
          <div class="form-text" style="margin-top: 0; margin-bottom: 0.5rem">
            Upload your CV in PDF format for review. Maximum file size is 10MB.
          </div>
          <div>
            <input
              type="file"
              id="file_cv"
              data-cy="cv"
              (change)="setFileData($event, 'cv', false)"
              accept=".pdf"
              jhiTranslate="entity.action.addblob"
            />
          </div>
          @if (editForm.get('cv')!.invalid && (editForm.get('cv')!.dirty || editForm.get('cv')!.touched)) {
            <div>
              @if (editForm.get('cv')?.errors?.required) {
                <small class="form-text text-danger" jhiTranslate="entity.validation.required">This field is required.</small>
              }
            </div>
          }
          <input type="hidden" class="form-control" name="cv" id="field_cv" data-cy="cv" formControlName="cv" />
          <input type="hidden" class="form-control" name="cvContentType" id="field_cvContentType" formControlName="cvContentType" />
        </div>
      </div>

      <div class="pt-3">
        <button type="button" id="cancel-save" data-cy="entityCreateCancelButton" class="btn btn-secondary" (click)="previousState()">
          <fa-icon icon="ban"></fa-icon>&nbsp;<span jhiTranslate="entity.action.cancel">Cancel</span>
        </button>

        <button
          type="submit"
          id="save-entity"
          data-cy="entityCreateSaveButton"
          [disabled]="editForm.invalid || isSaving"
          class="btn btn-primary"
        >
          <fa-icon icon="save"></fa-icon>&nbsp;<span jhiTranslate="recruitmentApp.jobApply.create.submit">Submit</span>
        </button>
      </div>
    </form>
  </div>
</div>
